// removed by extract-text-webpack-plugin
module.exports = {"progress":"_3qKQXvMyORvgv02P2-UFWk","requesting":"_3RmVdz3Wfa76qAoyApHvXx"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/password-change/PasswordChange.scss
// module id = 1640
// module chunks = 0